import _ from 'lodash';

export const selectFormLoader = (state) => _.get(state, ['formLoader'], false);